import axios from 'axios';
import i18n from 'i18next';

// const API_BASE_URL = 'http://localhost:8000/api';


const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});




// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = i18n.language;
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Don't attempt token refresh for login/signup endpoints or if already retried
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/login') &&
      !originalRequest.url.includes('/signup') &&
      !originalRequest.url.includes('/token/refresh')
    ) {
      const refreshToken = localStorage.getItem('refresh_token');
      
      if (refreshToken) {
        originalRequest._retry = true;
        
        try {
          const response = await axios.post(`${API_BASE_URL}/token/refresh/`, {
            refresh: refreshToken,
          });
          
          localStorage.setItem('access_token', response.data.access);
          originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
          
          return api.request(originalRequest);
        } catch (refreshError) {
          // Token refresh failed, clear storage and redirect to login
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
